import { TriggerBonusAction } from "../actions/creators/triggerBonusCreator"

const init = {
    loading: false,
    data: [],
    error: null,
}

export default function (state = init, action) {
    switch (action.type) {
        case TriggerBonusAction.getTriggerBonusSuccess:
            return { ...state, data: action.payload, error: null }
        case TriggerBonusAction.getTriggerBonusFromCache:
            return { ...state, data: action.payload, error: null }
        case TriggerBonusAction.getTriggerBonusLoading:
            return { ...state, loading: true }
        case TriggerBonusAction.getTriggerBonusLoaded:
            return { ...state, loading: false }
        case TriggerBonusAction.getTriggerBonusError:
            return { ...state, error: action.payload }
        default:
            return state
    }
}
